import { render, staticRenderFns } from "./SliderSwitcher.vue?vue&type=template&id=7e680313&"
import script from "./SliderSwitcher.vue?vue&type=script&lang=js&"
export * from "./SliderSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports